export const CATEGORY_PERFORMANCE_SET_APPLICATION = 'CATEGORY_PERFORMANCE_SET_APPLICATION';
export function setCategoryPerformanceApplication(payload) {
  return {
    type: CATEGORY_PERFORMANCE_SET_APPLICATION,
    payload
  };
}
